export const APP_CONFIG = {
    accessToken: process.env.REACT_APP_ACCESS_TOKEN,
    refreshToken: process.env.REACT_APP_REFRESH_TOKEN,
    profile: process.env.REACT_APP_PROFILE,
    apiUrl: process.env.REACT_APP_API_URL,
    apiUrlV2: process.env.REACT_APP_API_URL_V2
}